import { CommonModule } from '@angular/common';
import {
  Component,
  Output,
  EventEmitter,
  Input,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-upload-file',
  standalone: true,
  imports: [CommonModule, FlexLayoutModule, TranslateModule],
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent {
  constructor() {}
  selectedFile!: File;
  /** Display URL: internal preview when user selects file, or from parent when loaded from API */
  private _displayUrl = '';
  @Input() set imageUrl(value: string) {
    this._imageUrl = value || '';
    this._displayUrl = this._previewUrl || this._imageUrl;
  }
  get imageUrl(): string {
    return this._displayUrl;
  }
  private _imageUrl = '';
  private _previewUrl = '';
  @Input() isRequired: boolean = false;
  /** Variant: 'default' | 'business-logo' - business-logo shows label + photo size description like the registration form */
  @Input() variant: 'default' | 'business-logo' = 'default';
  /** Max file size in bytes. Default 20 MB */
  @Input() maxSizeBytes = 20 * 1024 * 1024;
  @Output() getFile = new EventEmitter<File>();
  /** Emits when selected file exceeds max size */
  @Output() fileSizeError = new EventEmitter<void>();
  /** Emits the data URL when a file is selected so the parent can display the preview */
  @Output() previewUrlChange = new EventEmitter<string>();
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  onFileSelected(event: any) {
    const file = event?.target?.files?.[0];
    if (!file) return;
    if (file.size > this.maxSizeBytes) {
      this.fileSizeError.emit();
      event.target.value = '';
      return;
    }
    this.selectedFile = file;
    this.getFile.emit(this.selectedFile);
    this.previewImage(this.selectedFile);
    event.target.value = '';
  }

  previewImage(file: File) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const dataUrl = e.target?.result as string;
      this._previewUrl = dataUrl;
      this._displayUrl = dataUrl;
      this.previewUrlChange.emit(dataUrl);
    };
    reader.readAsDataURL(file);
  }

  uploadImage() {
    // const formData = new FormData();
    // formData.append('image', this.selectedFile);
    // this.http.post<any>('your-upload-url', formData).subscribe(
    //   (response) => {
    //     this.imageUrl = response.imageUrl;
    //   },
    //   (error) => {
    //   }
    // );
  }

  onOpenFile(): void {
    this.fileInput.nativeElement.click();
  }
}
